import {Avatar} from '@mui/material'
import {FileWithArrowUp} from '../../../../assets/icons/fileWithArrowUp'

import {THead} from '../indicators-signals-table/IndicatorsSignalTable'

import {Link} from 'react-router-dom'
import {getSubjectId} from '../../../../pages/biomarkers/[id]/IndicatorsAndSignals'
import {EmptyTable} from '../../../../pages/subjects/Subject'
import {Button, FlexBlock} from '../../../customStyledElements'
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux";
import {Creator, CreatorTD} from '../indicators-signals-table/tableComponents'
import {ConnectButton} from "../../connectTo/interpretations/tableComponents";
import {FileWrapper, TDIdTableLInk} from '../interpretation/tableComponents'
import {RemoveBtn} from "../../../listMenu/listMenu";
import {patchRemove} from "../../../../redux/slice/data";
import React from "react";

const TITLE_LENGTH = 30

export const Empty = () => {
    return <EmptyTable name={'recommendation'}/>
}

export const NothingFound = () => {
    return (
        <tr>
            <td colSpan={1000} className={'nothing-found'}>
                Nothing Found ....
            </td>
        </tr>
    )
}

export const RecommendationsHead = () => {
    return (
        <THead>
            <tr>
                <td style={{width: '100px'}}>#</td>
                <td>Recommendations</td>
                <CreatorTD></CreatorTD>
                <td>Diseases</td>
            </tr>
        </THead>
    )
}

export const RecommendationsBody = (props: any) => {
    const {item, ind, onConnect, connectIds, language = 'en'} = props
    const {interpretations, indicators} = useAppSelector((state) => state.data)
    const linkTo = '/' + getSubjectId() + '/recommendations/' + item._id;
    const dispatch = useAppDispatch();

    return (
        <tbody>
        <tr>
            <TDIdTableLInk to={linkTo} item={item}></TDIdTableLInk>
            <td>
                <div data-td-center>

                {onConnect && <ConnectButton
                    item={item}
                    onConnect={onConnect}
                    connectIds={connectIds}
                />}
                <FileWrapper to={linkTo} top={5} abs={true}></FileWrapper>

                <Link to={linkTo} data-ellipse data-title>
                    {typeof item.name === 'object' 
                        ? item.name?.en || item.name?.[Object.keys(item.name || {})[0]] || ''
                        : item.name || ''}
                </Link>
                </div>

            </td>
            <td>
                <Creator item={item}/>
            </td>
            <td>
                <Link to={linkTo}>

                    <FlexBlock style={{overflowX: 'auto'}}>
                        {(item.interpretationIds || []).map((it: any, ind: number) => {
                            return (<Button key={ind} style={{maxHeight: '25px'}} data-ellipse>
                                {(() => {
                                    const interpretation = interpretations[it] || {};
                                    const name = interpretation.name;
                                    return typeof name === 'object' 
                                        ? name?.en || name?.[Object.keys(name || {})[0]] || '-'
                                        : name || '-';
                                })()}
                            </Button>)
                        })}

                    </FlexBlock>
                </Link>
                <RemoveBtn
                    name={typeof item.name === 'object' 
                        ? item.name?.en || item.name?.[Object.keys(item.name || {})[0]] || ''
                        : item.name || ''}
                    top={-32} onClick={() => {
                    dispatch(patchRemove({_id: item._id, type: 'recommendations'}))
                }}></RemoveBtn>
            </td>
        </tr>
        </tbody>
    )
}
